exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app h4[data-v-8dd7cb0c]{padding-left:.5rem;font-weight:700}.app p[data-v-8dd7cb0c]{padding:.375rem .5rem;text-align:justify;letter-spacing:.053333rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8dd7cb0c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/familyDoctor/FamilyArgeeMent.vue
// module id = 479
// module chunks = 0